import React from "react";
import { Platform, Switch, SwitchProps } from "react-native";
import { useTheme } from "./AHTheme/AHTheme";

type PickSwitchProps = Pick<
  SwitchProps,
  "value" | "onValueChange" | "disabled" | "hitSlop"
>;

export function AHSwitch(props: PickSwitchProps) {
  const theme = useTheme();

  const webProps =
    Platform.OS === "web" ? { activeThumbColor: theme["surface-primary"] } : {};

  return (
    <Switch
      style={{
        opacity: props.disabled ? 0.4 : 1,
      }}
      trackColor={{
        false: theme["surface-backgroundControl"],
        true: theme.primary,
      }}
      onValueChange={props.onValueChange}
      value={props.value}
      thumbColor={theme["surface-primary"]}
      {...webProps}
      {...props}
    />
  );
}
